export const datePickerDefaultOptions = [
  { label: 'Lifetime', value: [ '-10000', '0' ] }
]
  .concat(
    [ 7, 30, 60, 90, 180, 365 ]
      .map(n => ({
        label: `Last ${n} days`,
        value: [ `${n * -1}`, '0' ]
      }))
  )

export const sortOptions = [
  { label: 'Views', value: 'page_views' },
  { label: 'Date created', value: 'created_at' },
  { label: 'Social Actions', value: 'social_actions' },
  { label: 'Conversions', value: 'conversions' },
  { label: 'Duration', value: 'avg_duration' },
  { label: 'Word Count', value: 'avg_word_count' },
  { label: 'Avg. Time on Content', value: 'avg_active_time' },
  { label: 'Scroll Depth', value: 'avg_scroll_depth' }
]

export const nonMetricSortOptions = [
  { label: 'Date created', value: 'created_at' },
  { label: 'Duration', value: 'avg_duration' },
  { label: 'Word Count', value: 'avg_word_count' }
]

export const sortOrderOptions = [ 'asc', 'desc' ]

export const collectionActions = [
  { label: 'Create Collection', value: 'createCollection' },
  { label: 'Add to Collection', value: 'addToCollection' },
  { label: 'Remove from Collection', value: 'removeFromCollection' }
]

export const savedSearchActions = [
  { label: 'Save Search', value: 'saveSearch', disabled: false },
  { label: 'Update Saved Search', value: 'updateSearch', disabled: false }
]

export const exportActions = [
  { label: 'Export', value: 'export', disabled: true }
]
